import { Trans } from "react-i18next";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { AuthSlider } from "@/components/AuthSlider";
import { getAuthTokensFromLocalStorage } from "@/utils/auth";

const Layout = () => {
  const { pathname } = useLocation();

  // On /auth/* routes, if user already has tokens redirect to dashboard.
  // Prevents abandoned sessions from manual URL navigation to /auth/login while logged in.
  if (pathname.startsWith("/auth") && getAuthTokensFromLocalStorage()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen bg-white">
      <AuthSlider />
      <div className="flex flex-col overflow-y-auto w-full lg:w-1/2">
        <div className="flex flex-col w-full max-w-lg gap-6 px-4 mx-auto min-w-sm lg:px-6 py-12 my-auto">
          <Outlet />
        </div>
        <div className="py-4 text-xs text-center text-gray-500 mt-auto">
          <small className="text-sm">
            <Trans
              i18nKey="auth:footer.rights"
              values={{ year: new Date().getFullYear() }}
            />
          </small>
        </div>
      </div>
    </div>
  );
};

export default Layout;
